import 'core-js/stable';
import './custom.scss';
// import 'regenerator-runtime/runtime'
import * as React from 'react';
import { render } from 'react-dom';
import { Route, Router } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import { ThemeProvider } from 'styled-components';
import { QueryParamProvider } from 'use-query-params';
import { history } from './history';
import { defaultTheme, GlobalStyle } from '@styles';
// import { theme } from "@src/styles/theme"; // 전역 스타일 수정 후 사용

// import { BatchHttpLink } from "apollo-link-batch-http";
import { DeviceProvider } from '@src/providers/DeviceProvider/DeviceProvider';
import { SearchQueryProvider } from '@src/providers/SearchQueryProvider';
import { SnackbarProvider } from '@src/providers/SnackbarProvider';

import { transitions, positions, Provider as AlertProvider, useAlert } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { ApolloApp } from '@src/app';
import { getOrCreateGA4React, getUserId } from '@utils';

const alertOptions = {
  // you can also just use 'bottom center'
  position: positions.TOP_CENTER,
  timeout: 5000,
  offset: '400px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 9999,
  },
};

const startApp = async () => {
  const META_PIXEL_ID = process.env.REACT_META_PIXEL_ID;
  const BRANCH_KEY = process.env.REACT_BRANCH_KEY;

  if (META_PIXEL_ID) {
    // ReactPixel.init(META_PIXEL_ID);
  }

  if (BRANCH_KEY) {
    // init Branch
    // Change `key_live_YOUR_KEY_GOES_HERE` to match your Branch Dashboard
    // @ts-ignore
    branch.init(BRANCH_KEY);
  }

  if (process.env.GA_V4_TRACKING_ID) {
    /*
     * This snippet should be here, not in App.tsx file.
     * Because it has to be 'awaited'.
     * Otherwise, when a user refresh cart or checkout page,
     * Google Analytics 4 doesn't work at all (global ga object not loaded).
     * */
    await getOrCreateGA4React(process.env.GA_V4_TRACKING_ID);
  }
  render(
    <Router history={history}>
      <QueryParamProvider ReactRouterRoute={Route}>
        <AlertProvider template={AlertTemplate} {...alertOptions}>
          <DeviceProvider>
            <SearchQueryProvider>
              <SnackbarProvider>
                <ThemeProvider theme={defaultTheme}>
                  <GlobalStyle />
                  <ApolloApp />
                </ThemeProvider>
              </SnackbarProvider>
            </SearchQueryProvider>
          </DeviceProvider>
        </AlertProvider>
      </QueryParamProvider>
    </Router>,
    document.getElementById('root'),
  );
};

startApp();
